import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../../application/configurations/authConfig';
import { loginRequest } from '../../../application/configurations/authConfig';
import { store } from '../../../application/store';

/**
 * authenticate user by page redirection first time and then renew token silently
 * @param   {Object} msalHookInstance MSAL instance passed from component provider
 * or else create a new instance if missing
 * @param   {string} accounts user account information for renew token silently
 */
export const AuthService = (
  accounts?: Array<Object>,
  apiScopes?: string[],
  msalHookInstance?: any
) => {
  const userAccount = store.getState().general.account;
  /**
   * request object needs to pass to msal for silent token to feedback api access
   */
  const APIrequest = {
    scopes: apiScopes ? apiScopes : loginRequest.scopes,
    account: accounts && accounts.length > 0 ? accounts[0] : userAccount
  };

  /**
   * creating new instance or else use same if already available
   */
  const msalInstance = msalHookInstance
    ? msalHookInstance
    : new PublicClientApplication(msalConfig);

  /**
   * Silently acquires an access token which is then attached to a request for Microsoft Graph data
   */
  return msalInstance.acquireTokenSilent(APIrequest);
};
